import axios from 'axios'

export const AdminCountyService = {
  fetchCountyList (countryId, stateId, status) {
    let queryParams = '?'
    if (countryId !== undefined && countryId !== '') {
      queryParams += `cId=${countryId}&`
    }
    if (status !== undefined && status !== '') {
      queryParams += `status=${status}&`
    }
    if (stateId !== undefined && stateId !== '') {
      queryParams += `sId=${stateId}&`
    }
    return axios.get(`/api/v1/countylist${queryParams}`)
  },
  addCountyItem (data) {
    return axios.post(
      `/api/v1/addcounty`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  },
  editCountyItem (data) {
    return axios.post(
      `/api/v1/editcounty`,
      data,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  },
  getCountyDetailsById (id) {
    let queryParams = '?'
    if (id > 0) {
      queryParams += `cId=${id}`
    }
    return axios.get(`/api/v1/county${queryParams}`)
  },
  validateCountyItem (Data) {
    return axios.delete(`/api/v1/deletecounty`, { data: Data })
  },
  deleteCountyItem (Data) {
    return axios.delete(`/api/v1/deletecounty`, { data: Data })
  },
  searchCountyItem (data) {
    return axios.get(`/api/v1/countylist`, {
      params: {
        cId: data.countryId,
        sId: data.stateId,
        fips: data.fipsId,
        id: data.id,
        status: data.fstatus
      }
    })
  },
  fetchCountyFips () {
    return axios.get(`/api/v1/countyfips`)
  }
}
